<template>
  <div>
    <div class="row">
      <div class="w-100 text-center mt-3">
        <h3>Ordered from Regos app</h3>
      </div>
      <div class="w-100 mt-3 mb-3 p-3 border-bottom border-danger">
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>Start Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="fromDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>End Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="toDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-6 col-sm-4 d-md-inline-block mt-3">
          <button @click="fetchStats" :class="!fromDate || !toDate ? 'btn-outline-danger disabled' : 'btn-success'" class="btn px-5">
            SEARCH <b-icon-search shift-h="10"></b-icon-search>
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <area-chart
      :colors="['#dc3545']"
      :dataset="{borderWidth: 4}"
      :messages="{empty: 'Select date range to generate stats'}"
      :data="chartData">
    </area-chart>

    <div v-if="totalForRange" class="row overflow-hidden d-flex">
      <div class="col-md-4 col-sm-6 ml-auto">
        <table class="table font-weight-bolder float-right">
          <tr class="bg-success">
            <td class="text-right">TOTAL VALUE:</td>
            <td class="text-right">{{Math.round(totalForRange).toLocaleString('en')}} NOK</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import fixed from '../../fixed';

export default {
  name: 'RegosStats',
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    chartData: {},
    fromDate: null,
    toDate: null,
    totalForRange: 0,
  }),
  async mounted() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), 1);
    await this.fetchStats();
  },
  methods: {
    async fetchStats() {
      if (!this.fromDate || !this.toDate) return;

      this.totalForRange = 0;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/regos-stats?from=${moment(this.fromDate).format('yyyy-MM-DD')}&to=${moment(this.toDate).format('yyyy-MM-DD')}`,
          { withCredentials: true },
        );
        this.chartData = data.reduce((acc, curr) => {
          acc[curr._id] = curr.ordered.toFixed(2); // eslint-disable-line
          this.totalForRange += curr.ordered;
          return acc;
        }, {});
      } catch (error) {
        this.chartData = {};
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.info('No data for selected range');
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
